module.exports = __webpack_public_path__ + "static/media/login_banner-2.af9e4633.png";